import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  generateOrderImgPath(freightName: string) {
    let orderImagesPath = 'assets/images/product-types/';
    const freightNameWithoutClass = freightName.split(' ')[0];

    switch (freightNameWithoutClass) {
      case 'Пшеница':
        return (orderImagesPath += 'wheat.svg');
      case 'Лён':
        return (orderImagesPath += 'flax.svg');
      case 'Горох':
        return (orderImagesPath += 'peas.svg');
      case 'Кукуруза':
        return (orderImagesPath += 'corn.svg');
      case 'Рожь':
        return (orderImagesPath += 'rye.svg');
      case 'Ячмень':
        return (orderImagesPath += 'barley.svg');
      case 'Подсолнечник':
        return (orderImagesPath += 'sunflower.svg');
      default:
        return (orderImagesPath = '');
    }
  }
}
